import { gql } from '@apollo/client';
import { MeFragment } from '../fragments/MeFragment';
/**
 * @const MeQuery
 * @since 1.0.0
 */
export const MeQuery = gql `
  query MeQuery {
    me {
      ...MeFragment
    }
  }

  ${MeFragment}
`;
